<template>
    <div class="CompanyLogoForm">
        <strong>Company Logo</strong>

        <div class="container">
            <div
                class="previewContainer"
                @click="toggleShow"
            >
                <strong>Upload Logo</strong>

                <div
                    v-if="imgDataUrl"
                    class="preview"
                    :style="`background-image: url(${imgDataUrl})`"
                />
                <CompanyLogo v-else hide-admin-logo/>
            </div>

            <Button v-if="company.logo" class="danger outline" @click="handleRemoveLogo">Remove Logo</Button>
        </div>

        <FormImageCropUpload
            ref="formImageCropUpload"
            @change="handleChange"
            @click="toggleShow"
            @save="handleSave"
            hide-preview
            hide-save-btn
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as api from '@/api';
import CompanyLogo from '@/components/CompanyLogo';

export default {
    name: 'CompanyLogoForm',

    components: { CompanyLogo },

    data: () => ({
        imgDataUrl: '',
        formData: null,
        submitPending: false,
    }),

    computed: {
        ...mapGetters('auth', ['company']),
    },

    methods: {
        toggleShow() {
            this.$refs.formImageCropUpload.toggleShow();
        },

        async handleChange({ imgDataUrl, formData }) {
            this.imgDataUrl = imgDataUrl;
            this.formData = formData;

            await this.handleSave(formData);
        },

        async handleSave(formData) {
            if (!formData || this.submitPending) return;
            this.submitPending = true;

            const resPhoto = await api.postPhoto(formData);
            if (resPhoto.error) {
                return this.$awn.alert('Failed to upload company logo');
            }

            const logo = resPhoto.body.photo;
            const resCompany = await api.updateCompany(this.company.id, { logo });
            this.submitPending = false;

            if (resCompany.error) {
                this.submitError = resCompany.error;
                return this.$awn.alert('Failed to update company');
            }

            await this.$store.dispatch('auth/refreshUser');
            this.$awn.success('Logo updated!');
        },

        async handleRemoveLogo() {
            const res = await api.updateCompany(this.company.id, { logo: null });
            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error;
                return this.$awn.alert('Failed to remove logo');
            }

            window.location.reload();
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.CompanyLogoForm {
    .container {
        display: flex;
        align-items: center;
    }

    & > strong {
        display: block;
        margin-bottom: 10px;
    }

    .previewContainer {
        width: 120px;
        height: 120px;
        margin-right: 30px;
        border-radius: 50%;
        overflow: hidden;
        background-color: $bg-color-4;
        position: relative;
        text-align: center;
        cursor: pointer;

        &:before {
            @include overlay();
            content: '';
            display: block;
            background-color: #000;
        }

        strong {
            @include absolute-center();
            color: #fff;
        }

        &:before, strong {
            opacity: 0;
            transition: opacity 100ms ease-in;
            z-index: 1;
        }

        &:hover {
            &:before {
                opacity: 0.85;
            }

            strong {
                opacity: 1;
            }
        }
    }

    .preview {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
    }

    .CompanyLogo ::v-deep .logo {
        width: 100%;
        height: 100%;
        margin: 0;
    }
}
</style>
